module.exports = __webpack_public_path__ + "static/media/gameEnding_2.e0935239.mp3";